import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
import { objectTransform, storedProcParameters, makeResourceFirst } from "./apiUtils.js";
import demoParams from '../__test__/demoParams.js';
import dayjs from 'dayjs'
const { demoMode, demoListOfResourceCollectionsUserId } = demoParams;

const client = generateClient();

/**
 * Returns a list of resources in a collection by calling an api that gets the branchId using the userId.
 It then uses the branchId for a second api call to get all the resources in the collection.
 * @param {*String} userId
 */
export async function getListOfResourceCollection(userId) {
    const { companyId } = storedProcParameters;
    const getBranchesByUserId = await client.graphql(
        {
            query: queries.userApIgetBranch,
            variables: { userId, companyId }
        }
    );
    const branchId = getBranchesByUserId.data.userAPIgetBranch.userBranchId;

    let listOfResourceCollection = await client.graphql(
        {
            query: queries.resourceApIgetResourceCollection,
            variables: {
                userId: demoMode ? demoListOfResourceCollectionsUserId : userId,
                branchId
            }
        }
    );
    return listOfResourceCollection.data.resourceAPIgetResourceCollection;
}

/**
 *
 * api uses startDate ( object) to generate unix timestamps
 * for all the items (tours, assignments, meals) in the schedule
 * even passing in a string ('10/17/2020') will work ( converts it)
 * however we pass a  object
 * @param {*} startDate
 * @param {*} scheduleFormat
 * @param {*} resourceCollectionId
 * @param {*} userId
 * @param {*} resourceId
 */
export async function getLiveSchedules(
    startDate,
    scheduleFormat,
    resourceCollectionId,
    userId,
    resourceId,
    scheduleView
) {

    let sortedLiveScheduleArray;
    let timeZoneOffset = 0;

    let startDateFormat = startDate
    try {
        let liveScheduleArray = await client.graphql(
            {
                query:
                    queries.scheduleApIgetLiveSchedules,
                variables: {
                    startDate: startDateFormat,
                    scheduleFormat,
                    resourceCollectionId,
                    userId,
                    resourceId,
                    scheduleView
                }
            }
        );

        let labourScheduleArray = liveScheduleArray.data.scheduleAPIgetLiveSchedules.liveSchedule.labourSchedule;
        let facilityScheduleArray = liveScheduleArray.data.scheduleAPIgetLiveSchedules.liveSchedule.facilitySchedule;

        let combinedSchedules = [...labourScheduleArray, ...facilityScheduleArray]
        combinedSchedules = objectTransform(combinedSchedules);

        sortedLiveScheduleArray = combinedSchedules;
    } catch (error) {
        console.log(error);
        let errorString = '';
        for (let value of error.errors) {
            errorString = errorString + value.message;
        }
        alert(errorString);
    }

    // Readjusting schedule
    startDate = dayjs(startDate).add(timeZoneOffset, 'minute');
    startDate = startDate.toISOString();

    const liveSchedule = {
        startDate,
        scheduleFormat,
        resourceCollectionId,
        userId,
        resourceId,
        liveSchedule: sortedLiveScheduleArray
    };

    return liveSchedule;
}
